<script lang="ts"></script>

<style lang="scss" global>
  :host {
    width: fit-content;
  }
</style>
